(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
})((function () {
    /* eslint no-console: ["error", { allow: ["warn", "error"] }] */
    const __meta__ = {
        id: "polifill",
        name: "Polifill",
        category: "web",
        description: "A polifill for kendo. Typically injected in messages and cultures.",
        depends: [ ],
    };

    if (!window.kendo) {
        console.error("kendo is not loaded.", "Ensure that kendo scripts are loaded before this script.");
    }

    (function( window, undefined$1 ) {
        kendo.cultures["hsb-DE"] = {
            name: "hsb-DE",
            numberFormat: {
                pattern: ["-n"],
                decimals: 2,
                ",": ".",
                ".": ",",
                groupSize: [3],
                percent: {
                    pattern: ["-n %","n %"],
                    decimals: 2,
                    ",": ".",
                    ".": ",",
                    groupSize: [3],
                    symbol: "%"
                },
                currency: {
                    name: "Euro",
                    abbr: "EUR",
                    pattern: ["-n $","n $"],
                    decimals: 2,
                    ",": ".",
                    ".": ",",
                    groupSize: [3],
                    symbol: "€"
                }
            },
            calendars: {
                standard: {
                    days: {
                        names: ["njedźela","póndźela","wutora","srjeda","štwórtk","pjatk","sobota"],
                        namesAbbr: ["nje","pón","wut","srj","štw","pja","sob"],
                        namesShort: ["nj","pó","wu","sr","št","pj","so"]
                    },
                    months: {
                        names: ["januar","februar","měrc","apryl","meja","junij","julij","awgust","september","oktober","nowember","december"],
                        namesAbbr: ["jan","feb","měr","apr","mej","jun","jul","awg","sep","okt","now","dec"]
                    },
                    AM: ["dopołdnja","dopołdnja","DOPOŁDNJA"],
                    PM: ["popołdnju","popołdnju","POPOŁDNJU"],
                    patterns: {
                        d: "d.M.yyyy",
                        D: "dddd, d. MMMM yyyy",
                        F: "dddd, d. MMMM yyyy H:mm:ss",
                        g: "d.M.yyyy H:mm 'hodź'.",
                        G: "d.M.yyyy H:mm:ss",
                        m: "MMMM d",
                        M: "MMMM d",
                        s: "yyyy'-'MM'-'dd'T'HH':'mm':'ss",
                        t: "H:mm 'hodź'.",
                        T: "H:mm:ss",
                        u: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'",
                        y: "yyyy MMMM",
                        Y: "yyyy MMMM"
                    },
                    "/": ".",
                    ":": ":",
                    firstDay: 1
                }
            }
        };
    })();

}));
